import pkg from '../../../../package.json';

export const { dependencies, version } = pkg;

/**
 * Base URL for the CMS on the UNPKG CDN.
 */
export const UNPKG_BASE_URL = 'https://unpkg.com/@sveltia/cms';
